module.exports = __webpack_public_path__ + "static/media/f_eyeshape_monolid_brown.458de33f.png";